import IComic from '#/types/comics';

export const ComicsActionType = {
  COMICS_SET_COMICS: 'comics/set_comics',
  COMICS_SET_SEARCH: 'comics/set_search',
  COMICS_SET_SELECTED_FORMAT: 'comics/set_selected_format',
  COMICS_SET_PAGE: 'comics/set_page',
  COMICS_SET_TOTAL_PAGES: 'comics/set_total_pages',
  COMICS_START_LOADING: 'comics/start_loading',
  COMICS_STOP_LOADING: 'comics/stop_loading',
} as const;

export type TComicsActions =
  | {
      type: typeof ComicsActionType.COMICS_SET_COMICS;
      payload: IComic[];
    }
  | {
      type: typeof ComicsActionType.COMICS_SET_SEARCH;
      payload: string;
    }
  | {
      type: typeof ComicsActionType.COMICS_SET_SELECTED_FORMAT;
      payload: string;
    }
  | {
      type: typeof ComicsActionType.COMICS_SET_PAGE;
      payload: number;
    }
  | {
      type: typeof ComicsActionType.COMICS_SET_TOTAL_PAGES;
      payload: number;
    }
  | {
      type: typeof ComicsActionType.COMICS_START_LOADING;
    }
  | {
      type: typeof ComicsActionType.COMICS_STOP_LOADING;
    };
